<app-onbording *ngIf="english"></app-onbording>
<app-onboarding-hindi *ngIf="hindi"></app-onboarding-hindi>